<span class="text-muted me-2" *ngIf="message">{{ message }}</span><fa-icon [ngClass]="class" [icon]="spinnerIcon" [spin]="true"></fa-icon>
